import React, {useState, useEffect, useContext} from 'react';
import styles from './ErrorMessage.module.css';
// import {AppContext} from "../../redux/AppContext"; // import your css file
// import { useErrorMessage } from '../../redux/hooks';
// import {setErrorMessage, setInfoMessage} from "../../redux/actions";
// import {ThemeContext} from "../../redux/ThemeContext";
import {setErrorMessage,  setInfoMessage, useGlobalDispatch, useGlobalState} from "../../context/GlobalState";


function ErrorMessage() {
    const dispatch = useGlobalDispatch();
    const {errorMessage} = useGlobalState();

    // // const { setMessage } = useErrorMessage();
    // const { state, dispatch } = useContext(AppContext);
    // const { theme } = useContext(ThemeContext);
    // const { errorMessage} = state;
    const [showText, setShowText] = useState(null);

    useEffect(() => {
        if (errorMessage) {
            window._error = errorMessage
            console.log( "ErrorMessage:", errorMessage, JSON.stringify(errorMessage));
            // setShowText(errorMessage.toString());
            try {
                setShowText(typeof (errorMessage) == "string" ? errorMessage : JSON.stringify(errorMessage))
            } catch(error) {
                setShowText(errorMessage.toString());
            }
            const timer = setTimeout(() => {
                dispatch(setErrorMessage( null));
            }, 5000); // 10 seconds
            return () => clearTimeout(timer);
        }
    }, [errorMessage]);

    const handleCopyContent = (content) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(content).then(() => {
                console.log('Content copied to clipboard');
                dispatch( setInfoMessage('Content copied to clipboard'));

                // Optionally, you can display a message to the user indicating the copy was successful.
            }).catch(err => {
                console.error('Could not copy text: ', err);
            });
        } else {
            setErrorMessage( "Not supported in this browser");
        }
    };

    return errorMessage ? (
        <div className={styles["error-message"]}>
            <div
                onClick={() => handleCopyContent(showText)}
            >{showText}</div>
        </div>
    ) : null;
}

export default ErrorMessage;
